const ClearPillsButton = (props)=>{
    const clickEvent =()=>{
        props.callback();
    }
    return(<button
        type="button"
        className="button-link"
        onClick={() => clickEvent()}
      >
        {props.text}
      </button> 
    )
}
export default ClearPillsButton;